import { fetchMapLocations, selectMapStatus, selectPlaces } from 'containers/Maps/Map/mapSlice'
import PlaceElementForList from 'containers/Maps/Result/PlaceElementForList'
import WarehouseAttrPopup from 'containers/Maps/Popups/WarehouseAttrPopup'
import AutomationPopup from 'containers/Maps/Popups/AutomationPopup'
import SkeletonElement from 'containers/Maps/Result/SkeletonElement'
import { ReactComponent as Forward } from 'assets/forwardBtn.svg'
import { useReduxDispatch, useReduxSelector } from 'store'
import { LOCATION_STATES, STATUS } from 'utils/constants'
import useTranslation from 'hooks/useTranslation'
import usePopupState from 'hooks/usePopupState'
import { useHistory } from 'react-router-dom'
import Error from 'components/Error'
import { useEffect } from 'react'
import './style.scss'

export const POPUPS = {
  magMobile: 'magMobile',
  magStore: 'magStore',
  invest: 'invest',
}

const Home = () => {
  const { push } = useHistory()
  const { t } = useTranslation('home')
  const showPopup = p => {
    push(window.location.pathname, LOCATION_STATES.popup(p))
  }

  if (process.env.REACT_APP_TYPE !== 'mm') {
    return (
      <div className='home'>
        <div className='title'>
          <div>{t('rentAWarehouse')}</div>
          <div>{t('selectLocations')}</div>
        </div>
        <PlacesList />
      </div>
    )
  }

  return (
    <div className='home'>
      <div className='title'>
        <div>{t('yourMove')}</div>
        <div>{t('whatDoYouWantToDo')}</div>
      </div>

      <div className='list'>
        <div className='list__element --big'
          onClick={() => {
            showPopup(POPUPS.magStore)
          }}>
          <div className='element__group group'>
            <i className='icon icon--magStorage s32' />
            <i className='icon icon--dots' />
          </div>
          <div>
            <div className='element__title --secFont'>MagStore</div>
            <div className='element__text'>{t('sendUsYourItemsForStorage')}</div>
          </div>
          <div className='element__back'>
            <Forward />
          </div>
        </div>

        <div
          className='list__element'
          onClick={() => showPopup(POPUPS.magMobile)}>
          <div className='element__group group'>
            <i className='icon icon--magMobile s32' />
            <i className='icon icon--dots' />
          </div>
          <div>
            <div className='element__title --secFont'>MagMobile</div>
            <div className='element__text'>{t('orderAMobileWarehouse')}</div>
          </div>
          <div className='element__back'>
            <Forward />
          </div>
        </div>

        <div
          className='list__element --black'
          onClick={() => {
            push('/categories')
          }}>
          <i className='icon icon--logo s24 cWhite' />
          <div>
            <div className='element__title --secFont'>
              <div>{t('rent')}</div>
              <div>{t('warehouse')}</div>
            </div>
          </div>
          <div className='element__text'>Self-Storage</div>
        </div>

        <div
          className='list__element'
          onClick={() => {
            showPopup(POPUPS.invest)
          }}>
          <div className='element__group group'>
            <i className='icon icon--community s32' />
            <i className='icon icon--dots' />
          </div>
          <div className='element__title --secFont'>
            <div>{t('invest')}</div>
            <div>{t('inUs')}</div>
          </div>
          <div className='element__back'>
            <Forward />
          </div>
        </div>

        <div
          className='list__element'
          onClick={() => {
            push('/shop')
          }}>
          <div className='element__group group'>
            <i className='icon icon--shopping-bag s32' />
            <i className='icon icon--dots' />
          </div>
          <div>
            <div className='element__title --secFont'>MagShop</div>
            <div className='element__text'>{t('buyTheNecessaryAccessories')}</div>
          </div>
          <div className='element__back'>
            <Forward />
          </div>
        </div>
      </div>
    </div>
  )
}

const PlacesList = () => {
  const placesStatus = useReduxSelector(selectMapStatus)
  const places = useReduxSelector(selectPlaces)
  const { popup } = usePopupState()

  const { t } = useTranslation('home')
  const dispatch = useReduxDispatch()
  useEffect(() => {
    if (placesStatus === STATUS.idle) {
      dispatch(fetchMapLocations())
    }
  }, [dispatch, placesStatus])

  return (
    <>
      {popup?.type === 'warehouse_attr' && popup?.place_attrs && <WarehouseAttrPopup body={popup?.place_attrs} />}
      {popup?.type === 'automation' && popup?.automation && <AutomationPopup body={popup?.automation} />}
      <div className='home__placeList'>
        {places && places.length > 0
          ? <div className='resultList'>
            {places.map((place) => <PlaceElementForList
              isDesktop
              showButton
              data={place}
              key={place.id}
              customRedirect={`/mapdetails/${place.id}`}
            />)}
          </div>
          : placesStatus !== STATUS.succeed
            ? <div className='resultList'>
              {[1, 2].map((index) => <SkeletonElement
                isDesktop
                key={index}
              />)}
            </div>
            : <Error text={t('thereIsALackOfYards')} />}
      </div>
    </>
  )
}

export default Home